import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ibanFormat'
})
export class IbanFormatPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }
    // Remove all existing spaces and then insert a space every 4 characters.
    const cleaned = value.replace(/\s+/g, '');
    const formatted = cleaned.match(/.{1,4}/g)?.join(' ') || '';
    return formatted;
  }
}
